import { cloneDeep } from "lodash";

export function isValidMongoDBObjectID(i: string): boolean {
    /// https://stackoverflow.com/questions/11985228/mongodb-node-check-if-objectid-is-valid
    const id = i + "";
    const len = id.length;
    let valid = false;
    if (len === 24) {
        valid = /^[0-9a-fA-F]+$/.test(id);
    }
    return valid;
}

export function recursivelyRemoveKey(inObj: any, key: string) {
    function removeKeys(obj, key: string) {
        const isArray = obj instanceof Array;
        let k: any;
        for (k in obj) {
            if (k === key) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                isArray ? obj.splice(k, 1) : delete obj[k];
            } else if (typeof obj[k] === "object") {
                removeKeys(obj[k], key);
            }
            if (isArray && obj.length === k) {
                removeKeys(obj, key);
            }
        }
        return obj;
    }
    const obj = cloneDeep(inObj);
    return removeKeys(obj, key);
}
